import { ProCard, ProDescriptions } from '@ant-design/pro-components'
import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { AdTeamEditDrawer } from '@app/icare/routes/_app/adteam/-components/AdTeamEditDrawer'
import { t } from '@lingui/core/macro'
import { EditSectionButton } from '@pkg/ui/button'
import { TypedDescriptionsItem } from '@pkg/ui/proValueTypes'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/adteam/$id/')({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const { data } = useQuery(localQueryEntityOptions(params.id))

  if (!data) {
    return <ProCard loading />
  }

  const adTeam = data

  return (
    <ProCard
      headerBordered
      title={t`Allgemein`}
      extra={<EditSectionButton onClick={() => void AdTeamEditDrawer.show({ id: adTeam.id, section: 'general' })} />}
    >
      <ProDescriptions column={1} size="small" colon={false}>
        <TypedDescriptionsItem label={t`Name`}>{adTeam.name}</TypedDescriptionsItem>
        <TypedDescriptionsItem label={t`Entra-Gruppe`}>{adTeam.entraGroupName}</TypedDescriptionsItem>
      </ProDescriptions>
    </ProCard>
  )
}
